import { render, staticRenderFns } from "./TimeQuoteSettingDia.vue?vue&type=template&id=88452692&scoped=true"
import script from "./TimeQuoteSettingDia.vue?vue&type=script&lang=js"
export * from "./TimeQuoteSettingDia.vue?vue&type=script&lang=js"
import style0 from "./TimeQuoteSettingDia.vue?vue&type=style&index=0&id=88452692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88452692",
  null
  
)

export default component.exports